/**
 * Where the header's Back button takes a player: the game's page on the main site,
 * `<REACT_APP_BASE_URL>/game-detail/<gameId>`.
 *
 * Built from the player's own saved data so it survives a page refresh (it used to live only in memory,
 * set once at login - after a refresh on the final page Back went to the login screen) and does not depend
 * on the organisation lookup at login succeeding (it used to fall back to the bare base URL then).
 * Without a game id (demo players) it is the base URL; an explicitly saved redirect is used before that.
 */
export function resolveBackUrl(user, baseUrl = process.env.REACT_APP_BASE_URL) {
  const base = String(baseUrl || '').trim().replace(/\/+$/, '');
  const rawGameId = user && user.gameId != null ? String(user.gameId).trim() : '';
  const gameId = rawGameId === 'null' || rawGameId === 'undefined' ? '' : rawGameId;
  if (base && gameId) return `${base}/game-detail/${encodeURIComponent(gameId)}`;
  const saved = user && typeof user.backButtonRedirect === 'string' ? user.backButtonRedirect.trim() : '';
  if (saved) return saved;
  return base || null;
}
